module.exports = __webpack_public_path__ + "img/home_atrategy__img4——zh.88d29d71.png";